import { Col, Form as BSForm, Row } from 'react-bootstrap';
import SigniteToggle from '../../../../ui-elements/toggle-switch/signiteToggleSwitch';
import { FieldArray } from 'formik';
import LinkButton from '../../../../ui-elements/signite-link-button/linkButton';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { getErrorClass, getErrorMessage } from '../../../../../utils/errorUtils';

export const PreviousJobPromotionsForm = ({ handleChange, job, index, errors, touched, handleBlur }) => {
  return (
    <div className="signite-form">
      <Row>
        <BSForm.Group as={Col} controlId="hasGotPromotions">
          <BSForm.Label>Any Promotions you got during your career?</BSForm.Label>
          <SigniteToggle
            id={`previousJobs.${index}.hasGotPromotions`}
            dataYes={'Yes'}
            dataNo={'No'}
            fieldInput={{
              onChange: handleChange,
              value: job.hasGotPromotions,
            }}
          />
        </BSForm.Group>
      </Row>

      {job.hasGotPromotions && (
        <FieldArray name={`previousJobs.${index}.careerPromotions`}>
          {({ remove, push }) => (
            <>
              {job.careerPromotions &&
                job.careerPromotions.length > 0 &&
                job.careerPromotions.map((promotion, index2) => (
                  <Row className="mb-3" key={`row-${index2}`}>
                    <BSForm.Group as={Col}>
                      <BSForm.Label>Previous Designation*</BSForm.Label>
                      <BSForm.Control
                        type="text"
                        name={`previousJobs.${index}.careerPromotions.${index2}.previousDesignation`}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `previousJobs.${index}.careerPromotions.${index2}.previousDesignation`
                        )}`}
                        value={promotion.previousDesignation}
                      />
                      <span className="errorMessage">
                        {getErrorMessage(
                          errors,
                          touched,
                          `previousJobs.${index}.careerPromotions.${index2}.previousDesignation`
                        )}
                      </span>
                    </BSForm.Group>
                    <BSForm.Group as={Col}>
                      <BSForm.Label>Promotion Year*</BSForm.Label>
                      <BSForm.Control
                        type="number"
                        name={`previousJobs.${index}.careerPromotions.${index2}.promotionYear`}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `previousJobs.${index}.careerPromotions.${index2}.promotionYear`
                        )}`}
                        min={new Date().getFullYear() - 100}
                        value={promotion.promotionYear}
                      />
                      <span className="errorMessage">
                        {getErrorMessage(
                          errors,
                          touched,
                          `previousJobs.${index}.careerPromotions.${index2}.promotionYear`
                        )}
                      </span>
                    </BSForm.Group>
                    <BSForm.Group as={Col} className="d-flex align-items-center">
                      <LinkButton
                        label="Remove Promotion"
                        icon={faMinusCircle}
                        onClick={() => remove(index2)}
                      ></LinkButton>
                    </BSForm.Group>
                  </Row>
                ))}
              <Row className="mb-3">
                <Col>
                  <LinkButton
                    label="Add Promotions"
                    onClick={() =>
                      push({
                        previousDesignation: '',
                        promotionYear: '',
                      })
                    }
                  ></LinkButton>
                </Col>
              </Row>
            </>
          )}
        </FieldArray>
      )}
    </div>
  );
};
